import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import ValidationGroup from "../common/ValidationGroup";
import { orderByPropertyName } from "../../util/orderBy";
import { Popup } from 'semantic-ui-react';
import Tooltip from "../common/Tooltip";

const NieuwbouwInfrastructurenTable = props => {
	const {
		infrastructurenInDeBuurt,
		errors,
		validationMessageType,
		disabled
	} = props;

	const onEdit = (id) => {
		return function () {
			return props.onEdit(id);
		};
	};

	const onDelete = (id) => {
		return function () {
			return props.onDelete(id);
		};
	};

	function findById(id) {
		const type = props.soortenInfrastructuurAll.find(x => x.id === id);
		if (type) {
			return type.description;
		}
		return "Geen Type";
	}

	function findSporttakById(id, sporttakId) {
		const selectedSoortInfrastructuur = props.soortenInfrastructuur.find(x => x.id === id);
		if (selectedSoortInfrastructuur) {
			const sporttak = selectedSoortInfrastructuur.sporttakken.find(s => s.id === sporttakId);
			if (sporttak) {
				return sporttak.naam;
			}
		}
		return "";
	}

	const infrastructurenRows = orderByPropertyName(infrastructurenInDeBuurt, "naam").map((infrastructuur, i) => {
		const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID ? (
			<span>
				<br />{infrastructuur.andereInfrastructuur}
			</span>)
			: "";

		const icons = !disabled ? (
			<td>
				<span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={onEdit(infrastructuur.id)}/>} content="Wijzig infrastructuur" /></span>
				<span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-trash fa-fw" onClick={onDelete(infrastructuur.id)}/>} content="Verwijder infrastructuur" /></span>
			</td>) : <td/>;

		return (
			<tr key={i}>
				<td>{infrastructuur.naam}</td>
				<td>{findById(infrastructuur.soortInfrastructuurId)}{isTypeAndere}</td>
				<td>{findSporttakById(infrastructuur.soortInfrastructuurId, infrastructuur.sporttak)}</td>
				{icons}
			</tr>);
	});
	return (
		<ValidationGroup validationMessages={errors ? errors : undefined} validationMessageType={validationMessageType} >
			<table className="c-table hours">
				<thead>
					<tr>
						<th width={"35%"}>NAAM VAN DE INFRASTRUCTUUR</th>
						<th width={"20%"}>TYPE</th>
						<th width={"35%"}>WELKE SPORTTAK ZAL ER HOOFDZAKELIJK BEOEFEND WORDEN? <Tooltip text={"Je hoeft deze informatie enkel aan te vullen indien de sportinfrastructuur een natuur- of kunstgrasveld betreft"} /></th>
						<th width={"10%"}/>
					</tr>
				</thead>
				<tbody>
					{infrastructurenRows}
				</tbody>
			</table>
		</ValidationGroup>
	);
};

// ----------------------------------------------------------------------------
NieuwbouwInfrastructurenTable.propTypes = {
	infrastructurenInDeBuurt: PropTypes.arrayOf(PropTypes.object),
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
	onDelete: PropTypes.func,
	onEdit: PropTypes.func
};

export default NieuwbouwInfrastructurenTable;
